import http from "../http-common";

export const getRouteApiErrors = (date) => {
  const params = date ? { date } : {};
  return http.get("/route-api-errors", { params });
};
